<template>
  <a-button type="default" @click="handleEventOpen" class="mobile-menu-button">
    <menu-outlined />
  </a-button>

  <a-drawer
      v-model:open="openStatus"
      placement="right"
      :closable="true"
      @close="handleEventClose"
      :destroy-on-close="true"
      :keyboard="false"
      width="66%"
  >
    <a-menu
        theme="light"
        mode="inline"
        :items="menuList"
    >
    </a-menu>
  </a-drawer>
</template>

<script setup>
import { useRouter } from 'vue-router';
const router = useRouter();
import {MenuOutlined} from "@ant-design/icons-vue";
import {ref} from "vue";
const openStatus = ref(false)
const props = defineProps({
  menuList:{
    type: Array,
    default: []
  },
})
const handleEventClick = (e) => {
  //用路由跳转
  router.push({
    path: e.item.path,
    // query: { id: 123, name: 'John' },
  });
}

const handleEventOpen = () => {
  openStatus.value = true
}
const handleEventClose = () => {
  openStatus.value = false
}
</script>


<style scoped>
/* 增加特异性和使用深度作用选择器 */
:deep(.ant-menu .ant-menu-inline),
:deep(.ant-menu .ant-menu-vertical) {
  border-inline-end: none !important;
}
</style>